import { Component, ElementRef, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { CDSMask } from '@app/utils/cds-mask';
import debounce from '@app/utils/debounce';
import { RelatorioService } from '@app/services/relatorio.service';
import { ConsultasService } from '@app/services/consultas.service';

import { IdDescricao } from '@app/models/util/id-descricao';
import { FiltrosReceberAtrasadosRelatorios, ReceberAtrasadosRelatorios } from '@app/models/receber-atrasados-relatorios';
import { ToastrService } from 'ngx-toastr';
import { UtilitarioService } from '@app/services/utilitario.service';

@Component({
  selector: 'app-recebimentos-atrasados',
  templateUrl: './recebimentos-atrasados.component.html',
  styleUrls: ['./recebimentos-atrasados.component.scss']
})
export class RecebimentosAtrasadosComponent implements OnInit {

  cdsMask: CDSMask = new CDSMask();
  filtros: FiltrosReceberAtrasadosRelatorios = new FiltrosReceberAtrasadosRelatorios();
  lstReceberAtrasados: ReceberAtrasadosRelatorios[] = [];

  lstParticipante: Array<any> = [{}];
  lstUnidades: IdDescricao[];

  nomeParticipanteRelatorio: string = "";

  totalReceber = 0;
  pesquisando: boolean;
  showTable: boolean = false;

  dataRelatorio: Date;

  _debounce: any;
  _pesquisa: any;

  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService
  ) {

  }

  ngOnInit() {
    this.filtros.ProcessoId = null;
    this.filtros.TipoData = 'Vencimento';
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);
  }

  pesquisar() {
    this.dataRelatorio = new Date();
    this.lstReceberAtrasados = [];
    if (this.filtros.DataFinal === undefined || this.filtros.DataInicial === undefined) {
      this.toastr.error('Os campos de Data Inicial/Data Final devem ser preenchidos');
    } else {
      this.pesquisando = true;
      this.relatorioService.receberAtrasados(this.filtros)
        .toPromise().then((data) => {
          this.lstReceberAtrasados = data;
          this.somaSaldo();
          this.pesquisando = false;

          if (this.lstReceberAtrasados.length === 0) {
            this.toastr.info("Busca não encontrou resultados");
            this.showTable = false;
          } else {
            this.showTable = true;
          }
        }, erro => {
          this.pesquisando = false
          this.toastr.warning("Realize a pesquisa novamente.")
        });
      //  () => this.pesquisando = false);
    }
  }

  public somaSaldo(): void {
    this.totalReceber = 0;
    this.lstReceberAtrasados.forEach(element => { this.totalReceber += element.Valor; });
  }


  @ViewChild('relatorio') relatorio: ElementRef;
  public imprimir() {
    let conteudo = document.getElementById("rel-recebimentosatrasados").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório recebimentos atrasados", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    adicionaMapValido('Cod. Processo', this.filtros.ProcessoId);

    adicionaMapValido('Participante', this.nomeParticipanteRelatorio);
    obtemDescricaoAdicionaMap('Unidade', this.lstUnidades, this.filtros.UnidadeId);

    parseDateAdicionaMap(this.filtros.TipoData, ' Inicial', this.filtros.DataInicial);
    parseDateAdicionaMap(this.filtros.TipoData, ' Final', this.filtros.DataFinal);
    

    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, inicialFinal: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData + inicialFinal, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

}
